<template>
  <div>
    <card>
      <div class="card-header-custom">
        <button type="submit" @click="toggleSelectAll" class="btn btn-fill btn-primary mr-3">
          Alle auswählen
        </button>

        <button class="btn btn-success" @click="restoreSelectedCauses">
          <i class="fa fa-recycle"></i>
          Ausgewählte Gründe wiederherstellen
        </button>
      </div>
      <p v-if="causes.length === 0"> Es gibt keine gelöschten Gründe.</p>
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-striped"  v-if="causes.length">
            <thead>
                <th></th>
                <th>Name</th>
            </thead>
            <tr v-for="cause in causes" :key="cause.id">
              <td style="width: 30px;">
                <input type="checkbox" :value="cause.id" v-model="selectedCauses">
              </td>
              <td v-text="cause.name"></td>
            </tr>
          </table>
        </div>
      </div>
      <a href="/causes">
         <button type="submit" class="btn btn-fill btn-info mr-3">
          Zurück
        </button>
      </a>
    </card>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: { draggable },
  data() {
    return {
      causes: [],
      selectAll: false,
      selectedCauses: []
    }
  },
  methods: {
    toggleSelectAll() {
      this.selectAll = !this.selectAll
      if (this.selectAll) {
        this.selectedCauses = this.causes.map(cause => cause.id);
      } else {
        this.selectedCauses = [];
      }
    },
    restoreSelectedCauses() {
      if (this.selectedCauses.length) {
        const selectedCauses = this.causes.filter(cause => this.selectedCauses.includes(cause.id));
        const selectedCausesIds = selectedCauses.map(cause => cause.id)
        const selectedCausesNames = selectedCauses.map(cause => cause.name)
        this.$http.post(`/soft_deleted/causes/restore`, { ids: selectedCausesIds }).then(() => {
          this.$notify({
            message: `Grund/Gründe ${selectedCausesNames} erfolgreich zurückgesetzt.`,
            type: 'success'
          });
          this.fetchData();
          setTimeout(() => {
            this.$router.push('/causes');
          }, 2000);
        })
      }
    },
    fetchData() {
      this.$http.get('soft_deleted/causes').then(({ data }) => { this.causes = data })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>
